module.exports = __webpack_public_path__ + "img/popcorn.3dc6480c.png";